export default __webpack_public_path__ + "static/susanArticleThumbnail-c3df41d7358748588166279185efb5ac.jpg";